/* Bodi build-your-pack scent selector.
   Tiles -> ADD/qty stepper -> live "x/min" counter -> gated Add-to-cart that
   AJAX-adds each chosen scent as its own line item. Clicking a tile previews
   that scent (dispatches `bodi:scent-preview` for the hero/notes). */
(function () {
  if (customElements.get('bodi-scent-pack')) return;

  class BodiScentPack extends HTMLElement {
    connectedCallback() {
      this.min = parseInt(this.dataset.min || '1', 10);
      this.noun = this.dataset.noun || 'refills';
      this.nounSingular = this.noun.replace(/s$/, '');
      this.tiles = Array.prototype.slice.call(this.querySelectorAll('.bsp-tile'));
      this.counter = this.querySelector('[data-bsp-counter]');
      this.atc = this.querySelector('[data-bsp-atc]');
      this.qty = {};

      this.tiles.forEach((t) => this._wireTile(t));
      if (this.atc) this.atc.addEventListener('click', () => this._addToCart());
      this._render();

      // preview the first scent once everything is connected
      const first = this.tiles[0];
      if (first) window.setTimeout(() => this._preview(first.dataset.scent, first), 0);
    }

    _wireTile(t) {
      const id = t.dataset.variantId;
      this.qty[id] = 0;
      const add = t.querySelector('[data-bsp-add]');
      const preview = t.querySelector('[data-bsp-preview]');

      if (preview) preview.addEventListener('click', () => this._preview(t.dataset.scent, t));
      if (add && !add.disabled) {
        add.addEventListener('click', () => {
          this.qty[id] = 1;
          this._sync(t);
          this._preview(t.dataset.scent, t);
          this._render();
        });
      }
      const inc = t.querySelector('[data-bsp-inc]');
      const dec = t.querySelector('[data-bsp-dec]');
      if (inc) inc.addEventListener('click', () => { this.qty[id]++; this._sync(t); this._render(); });
      if (dec) dec.addEventListener('click', () => { this.qty[id] = Math.max(0, this.qty[id] - 1); this._sync(t); this._render(); });
    }

    _sync(t) {
      const id = t.dataset.variantId;
      const q = this.qty[id];
      const add = t.querySelector('[data-bsp-add]');
      const stepper = t.querySelector('[data-bsp-stepper]');
      const qtyEl = t.querySelector('[data-bsp-qty]');
      if (q > 0) {
        if (add) add.hidden = true;
        if (stepper) stepper.hidden = false;
        if (qtyEl) qtyEl.textContent = q;
        t.classList.add('is-active');
      } else {
        if (add) add.hidden = false;
        if (stepper) stepper.hidden = true;
        t.classList.remove('is-active');
      }
    }

    _total() {
      let n = 0;
      for (const id in this.qty) n += this.qty[id];
      return n;
    }

    _totalCents() {
      let c = 0;
      this.tiles.forEach((t) => { c += (this.qty[t.dataset.variantId] || 0) * parseInt(t.dataset.price || '0', 10); });
      return c;
    }

    _render() {
      const total = this._total();
      const remaining = Math.max(0, this.min - total);
      if (!this.atc) return;
      if (remaining > 0) {
        if (this.counter) {
          this.counter.style.display = '';
          this.counter.textContent =
            total === 0
              ? (this.min === 1
                  ? 'Pick a ' + this.nounSingular + ' to get started'
                  : 'Pick at least ' + this.min + ' ' + this.noun + ' to get started')
              : remaining + ' more to go — ' + total + ' in your pack';
        }
        this.atc.disabled = true;
        this.atc.textContent = this.min === 1 ? 'Add to cart' : 'Add ' + remaining + ' more';
      } else {
        // minimum reached — hide the counter; show the combined total on the button
        if (this.counter) { this.counter.textContent = ''; this.counter.style.display = 'none'; }
        this.atc.disabled = false;
        this.atc.textContent = 'Add to cart · $' + (this._totalCents() / 100).toFixed(2);
      }
    }

    _preview(scent, tile) {
      this.tiles.forEach((t) => t.classList.toggle('is-previewing', t === tile));
      document.dispatchEvent(new CustomEvent('bodi:scent-preview', { detail: { key: scent } }));
    }

    _addToCart() {
      const items = [];
      for (const id in this.qty) {
        if (this.qty[id] > 0) items.push({ id: Number(id), quantity: this.qty[id] });
      }
      if (!items.length || this._total() < this.min) return;

      this.atc.disabled = true;
      this.atc.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then((r) => {
          if (!r.ok) throw new Error('add failed');
          window.location.href = '/cart';
        })
        .catch(() => {
          this.atc.disabled = false;
          this.atc.textContent = 'Try again';
        });
    }
  }

  customElements.define('bodi-scent-pack', BodiScentPack);
})();
